// O que uma mensagem de mídia "diz" quando não tem legenda — usado na citação
// (balão e composer), onde o corpo vazio deixava a caixa em branco.
//
// Cobre os dois vocabulários gravados em `Messages.mediaType`: o dos
// tradutores de entrada (image/video/audio/ptt/document/sticker/location/
// vcard) e o dos envios da tela (primeira parte do mimetype — "application"
// para documento).
const ROTULOS = {
  image: "📷 Foto",
  video: "🎥 Vídeo",
  audio: "🎧 Áudio",
  ptt: "🎧 Áudio",
  sticker: "📷 Figurinha",
  document: "📄 Documento",
  application: "📄 Documento",
  location: "📍 Localização",
  vcard: "👤 Contato",
};

export const rotuloDeMidia = (mediaType) => ROTULOS[mediaType] || "";

// A citação mostra miniatura só do que tem imagem para mostrar.
export const temMiniatura = (message) =>
  Boolean(message?.mediaUrl) &&
  ["image", "sticker", "video"].includes(message?.mediaType);
